<template>
  <div class="infos-view">
    <div class="employee-city">
      <div class="line employee">
        <div class="field">
          {{ $t("editEventCard.employee") }}
        </div>
        <div class="data">
          {{ this.fullName }}
        </div>
      </div>
      <div class="line city">
        <div class="field">
          {{ $t("editEventCard.location") }}
        </div>
        <div class="data" :style="{ color: event.location.color }">
          {{ event.location.city }}
        </div>
      </div>
    </div>
    <div class="dates-times">
      <div class="line dates">
        <div class="field">
          {{ $t("editEventCard.date") }}
        </div>
        <div class="data">
          <div class="data">
            {{ $t("editEventCard.from") }}
            {{ event.dateStart }}
          </div>
          <div class="data">
            {{ $t("editEventCard.to") }}
            {{ event.dateEnd }}
          </div>
        </div>
      </div>
      <div v-if="event.timeStart || event.timeEnd" class="line times">
        <div class="field">
          {{ $t("editEventCard.eachDay") }}
        </div>
        <div class="data">
          <div v-if="event.timeStart" class="data">
            <v-icon>mdi-clock-start</v-icon>
            {{ $t("editEventCard.eachDayFrom") }}
            {{ event.timeStart }}
          </div>
          <div v-if="event.timeEnd" class="data">
            <v-icon>mdi-clock-end</v-icon>
            {{ $t("editEventCard.eachDayTo") }}
            {{ event.timeEnd }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="event.comment" class="comment">
      <div class="field">
        {{ $t("editEventCard.comment") }}
      </div>
      <div class="data">
        {{ event.comment }}
      </div>
    </div>
    <div class="line type">
      <div class="field">
        {{ $t("editEventCard.types") }}
      </div>
      <div class="data">
        {{ returnEventTypeDialog(event.type) }}
        {{ $t(this.type) }}
      </div>
    </div>
    <div class="line valid">
      <div class="field">{{ $t("editEventCard.status") }}</div>
      <div class="data">
        {{
          event.validated
            ? $t("editEventCard.validatedTrue")
            : $t("editEventCard.validatedFalse")
        }}
      </div>
    </div>
    <div class="line attendees">
      <div class="field">{{ $t("editEventCard.attendeesCount") }}</div>
      <div class="data">
        {{ event.attendeesCount }}
      </div>
    </div>
    <div class="line attendees">
      <div class="field">{{ $t("editEventCard.customers") }}</div>
      <div class="data">
        {{ event.customers }}
      </div>
    </div>
    <div class="line duration">
      <div class="field">{{ $t("editEventCard.courseDuration") }}</div>
      <div class="data">
        {{ this.realDuration }}
        {{
          this.realDuration > 1
            ? $t("editEventCard.durationMultipleDays")
            : $t("editEventCard.durationSingleDay")
        }}
      </div>
    </div>
    <div
      v-if="this.event.slug != null && this.event.optionSlug == null"
      class="line master"
    >
      <div class="field">{{ $t("editEventCard.slug") }} :</div>
      <div class="data">
        <a
          target="_blank"
          :href="
            Links.DawanOrgShowTrainingSession(
              event.slug.split('-customers-')[0]
            )
          "
          >{{ this.event.slug.split("-customers-")[0] }}</a
        >
      </div>
    </div>
    <div v-if="this.event.optionSlug != null" class="line master">
      <div class="field">{{ $t("editEventCard.optionSlug") }} :</div>
      <div class="data">
        <a
          target="_blank"
          :href="
            Links.DawanOrgShowSessionOption(
              event.optionSlug.slice(0, this.event.slug.length - 7)
            )
          "
          >{{ this.event.optionSlug.slice(0, this.event.slug.length - 7) }}
        </a>
      </div>
    </div>
    <div v-if="this.event.masterIntervention != null" class="line master">
      <div class="field">{{ $t("editEventCard.linkParent") }} :</div>
      <div class="data">
        <a
          target="_blank"
          :href="
            Links.DawanOrgShowTrainingSession(
              event.masterIntervention.slug.split('-customers-')[0]
            )
          "
          >{{ this.event.masterIntervention.slug.split("-customers-")[0] }}
        </a>
      </div>
    </div>
    <div v-if="this.event.quotations != null">
      <div v-if="this.event.quotations.length > 0" class="line master">
        <div class="field">
          {{ $t("editEventCard.quotations") }}
        </div>
        <div class="data">
          <div
            v-for="(quotation, index) in event.quotations"
            :key="index + quotation.slug"
          >
            <a
              target="_blank"
              :href="Links.DawanOrgShowEstimate(quotation.slug)"
              >{{ quotation.companyName }}
            </a>
            ({{ quotation.estimateAuthor }})
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { DateTime, Interval } from "luxon";
import Links from "@/models/Links";

export default {
  name: "view-event-info",
  props: {
    linkedIntervention: {},
    event: {
      x: null,
      id: null,
      duration: null,
      display: null,
      details: {},
      color: null,
      userType: null,
      location: null,
      course: null,
      userName: null,
      eventSiblings: [],
      attendees: null,
    },
  },
  data() {
    return {
      realDuration: null,
      fullName: "",
      Links: Links,
    };
  },
  computed: {
    ...mapGetters("eventModule", {
      masterInterventions: "getMasterEvents",
      events: "getEvents",
    }),
    ...mapGetters("freeDaysModule", {
      holidays: "getHolidays",
      weekEndDays: "getWeekEndDays",
    }),
  },
  async mounted() {
    this.watchEdit();
  },
  watch: {
    "event.duration"() {
      this.watchEdit();
    },
    "event.dateStart"() {
      this.watchEdit();
    },

    "event.dateEnd"() {
      this.watchEdit();
    },
    "event.user"() {
      this.watchEdit();
    },
  },
  methods: {
    ...mapActions("freeDaysModule", ["getWeekEndDays", "getHolidays"]),
    returnEventTypeDialog(t) {
      switch (t) {
        case "INTERN":
          this.type = "enumIntStatus.internal";
          break;
        case "INTRA":
          this.type = "enumIntStatus.custom";
          break;
        case "POE":
          this.type = "enumIntStatus.eop";
          break;
        case "TP":
          this.type = "enumIntStatus.professionalTitle";
          break;
        default:
          this.type = "enumIntStatus.undefined";
          break;
      }
    },
    getHolydayCountForEvent(start, duration) {
      let startDate = new Date(start);
      let count = 0;

      for (let i = 0; i < duration; i++) {
        if (
          this.holidays.includes(this.formatDate(startDate)) ||
          this.weekEndDays.includes(this.formatDate(startDate))
        ) {
          count++;
        }
        startDate.setDate(startDate.getDate() + 1);
      }
      return count;
    },
    formatDate(date) {
      return (
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2)
      );
    },
    watchEdit() {
      const dateStart = new DateTime.fromISO(this.event.dateStart);
      const dateEnd = new DateTime.fromISO(this.event.dateEnd).plus({
        days: 1,
      });
      const duration = new Interval.fromDateTimes(dateStart, dateEnd).length(
        "days"
      );
      if (this.event.duration) {
        this.realDuration =
          this.event.duration -
          this.getHolydayCountForEvent(
            this.event.dateStart,
            this.event.duration
          );
      } else {
        this.realDuration =
          duration -
          this.getHolydayCountForEvent(this.event.dateStart, duration);
      }

      if (typeof this.event.user.details === "undefined") {
        this.fullName = this.event.user.fullName;
      } else {
        this.fullName = this.event.user.details.fullName;
      }
    },
  },
};
</script>

<style lang="scss">
.infos-view {
  padding: 0 10px 0 0;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  height: 100%;
  margin: 20px 10px 0;

  .line {
    display: flex;
    justify-content: space-between;
    padding: 0 0 15px;
    margin: 0 0 15px;
    border-bottom: 1px solid var(--border-color);
  }

  .field {
    color: rgb(155, 155, 155);
  }

  .comment {
    text-align: justify;
    margin: 0 0 15px;
    padding: 0 0 15px;
    border-bottom: 1px solid var(--border-color);
  }

  .master {
    .data {
      text-align: right;
    }
  }
}
</style>
